import { clearPhone } from '../../../utils/phone/clearPhone';

export const preparePhoneDisplay = (phone: string): string => {
  const phoneNumber = clearPhone(phone);

  return phoneNumber.replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{0,2})/, '+$1 ($2) $3-$4-$5');
};
